import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() textPlaceholder?: string = '';
  @Input() searchValue: string = '';
  @Input() firstBtnText?: string = '';
  @Input() iconFirstBtn?: string = '';
  @Input() secondBtnText?: string = '';
  @Input() iconSecondBtn?: string = '';
  @Input() thirdBtnText?: string = '';
  @Input() iconThirdBtn?: string = '';
  @Input() viewMode: 'grid' | 'list' = 'grid';
  @Input() downloadDisabled = false;
  @Input() hideDownloadWhenDisabled = true;
  @Input() firstBtnDisabled = false;
  @Input() firstBtnDisabledReason = '';

  @Output() clikedFirstButton = new EventEmitter<boolean>();
  @Output() clikedSecondButton = new EventEmitter<boolean>();
  @Output() clikedThirdButton = new EventEmitter<boolean>();
  @Output() viewModeChange = new EventEmitter<'grid' | 'list'>();
  @Output() planilhaAction = new EventEmitter<'download-template' | 'import' | 'export'>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() downloadClick = new EventEmitter<void>();

  isPlanilhaMenuOpen = false;


  get isCadastrarProdutos(): boolean {
    return this.title === 'Cadastrar Produtos';
  }

  get isCartelas(): boolean {
    return this.title === 'Cartelas';
  }

  get isClientes(): boolean {
    return this.title === 'Meus Clientes';
  }

  get isConfiguracoes(): boolean {
    return this.title === 'Configurações';
  }

  get isLoja(): boolean {
    return this.title === 'Loja';
  }

  get isPedidos(): boolean {
    return this.title === 'Pedidos' || this.title === 'Meus Pedidos';
  }

  get isPlayer(): boolean {
    return this.title === 'Minha Conta';
  }

  clickFirstButton(){
    if (this.firstBtnDisabled) {
      return;
    }
    this.clikedFirstButton.emit(true);
  }

  clickSecondButton(){
    this.clikedSecondButton.emit(true);
  }

  clickThirdButton(){
    this.clikedThirdButton.emit(true);
  }

  togglePlanilhaMenu(): void {
    this.isPlanilhaMenuOpen = !this.isPlanilhaMenuOpen;
  }

  selectPlanilhaAction(action: 'download-template' | 'import' | 'export'): void {
    this.planilhaAction.emit(action);
    this.isPlanilhaMenuOpen = false;
  }

  setViewMode(mode: 'grid' | 'list'): void {
    if (this.viewMode === mode) {
      return;
    }

    this.viewMode = mode;
    this.viewModeChange.emit(mode);
  }

  onSearchInput(event: Event): void {
    const target = event.target as HTMLInputElement | null;
    this.searchChange.emit(target?.value ?? '');
  }

  onDownloadClick(): void {
    if (this.downloadDisabled) {
      return;
    }

    this.downloadClick.emit();
  }
}
